module.exports = __webpack_public_path__ + "static/media/bg.ed64d89a.png";